import React, { useEffect, useRef, useState } from "react";
import { Truck, Clock } from "lucide-react";
import { api } from "../lib/api";
import { useI18n } from "../i18n";

const pad = (n) => String(n).padStart(2, "0");

function fmtDate(iso, locale) {
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`; // dd/mm/yyyy
}

export const ShippingCountdown = () => {
  const { t, lang } = useI18n();
  const [est, setEst] = useState(null);
  const [remaining, setRemaining] = useState(0);
  const skewRef = useRef(0); // serverNow - clientNow at fetch

  const load = async () => {
    try {
      const { data } = await api.get("/shipping/estimate");
      const serverNow = Date.parse(data.server_now);
      skewRef.current = serverNow - Date.now();
      setEst(data);
    } catch (_) {
      /* keep quiet on failure */
    }
  };

  useEffect(() => {
    load();
  }, []);

  useEffect(() => {
    if (!est) return;
    const cutoff = Date.parse(est.cutoff);
    const tick = () => {
      const nowServer = Date.now() + skewRef.current;
      const rem = Math.floor((cutoff - nowServer) / 1000);
      if (rem <= 0) {
        load(); // cutoff passed — refetch next window
      } else {
        setRemaining(rem);
      }
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [est]);

  if (!est || remaining <= 0) return null;

  const hh = Math.floor(remaining / 3600);
  const mm = Math.floor((remaining % 3600) / 60);
  const ss = remaining % 60;

  return (
    <div className="flex justify-center mb-5 px-2" data-testid="shipping-countdown">
      <div className="inline-flex items-center gap-3 bg-nbyellow nb-border nb-shadow rounded-full px-6 py-3 font-head font-extrabold text-base sm:text-xl whitespace-nowrap">
        <Clock size={22} className="shrink-0 text-nbpink" />
        <span className="whitespace-nowrap">
          {t("designer.shipOrderIn")}{" "}
          <span className="tabular-nums text-nbpink" data-testid="countdown-timer">
            {pad(hh)}:{pad(mm)}:{pad(ss)}
          </span>{" "}
          {t("designer.shipGetBy")}{" "}
          <span className="inline-flex items-center gap-1 align-middle">
            <Truck size={20} className="shrink-0" />
            <span data-testid="ship-date">{fmtDate(est.ship_date, lang)}</span>
          </span>
        </span>
      </div>
    </div>
  );
};
